import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './dialog';
import { Input } from './input';
import { Button } from './button';

interface TestEmailDialogProps {
	isOpen: boolean;
	onOpenChange: (isOpen: boolean) => void;
	onSendEmail: (email: string) => void;
	isEmailing: boolean;
}

const TestEmailDialog: React.FC<TestEmailDialogProps> = ({
	isOpen,
	onOpenChange,
	onSendEmail,
	isEmailing
}) => {
	const [testEmailAddress, setTestEmailAddress] = useState('');
	const [testEmailError, setTestEmailError] = useState('');

	const handleSendEmail = () => {
		if (!testEmailAddress) {
			setTestEmailError('Email address is required');
			return;
		}
		setTestEmailError('');
		onSendEmail(testEmailAddress);
	};

	return (
		<Dialog open={isOpen} onOpenChange={onOpenChange} aria-labelledby="email-test-dialog">
			<DialogContent>
				<DialogHeader>
					<DialogTitle id="email-test-dialog">Send Test Email</DialogTitle>
				</DialogHeader>
				Enter the email address to which you'd like to send the test email.
				<Input
					autoFocus
					id="test-email"
					type="email"
					value={testEmailAddress}
					onChange={(e) => setTestEmailAddress(e.target.value)}
				/>
				{testEmailError && <p style={{ color: 'red' }}>{testEmailError}</p>}
				<DialogFooter>
					<Button
						onClick={() => {
							onOpenChange(false);
							setTestEmailAddress('');
							setTestEmailError('');
						}}
						disabled={isEmailing}
					>
						Cancel
					</Button>
					<Button onClick={handleSendEmail} disabled={isEmailing}>
						{isEmailing ? 'Sending...' : 'Send'}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default TestEmailDialog;
